import {CurrentUserService} from "../../services/user/CurrentUserService";
import {CurrentUser} from "../../services/user/models/CurrentUser";
import {defaultTheme, themingEnabled} from "../../types/Branding";
import {Observable, ReplaySubject} from "rxjs";
import {ThemeType} from "../../types/UserConfig";

export class ThemingStore {

    public static readonly id = "themingStore";

    private readonly toggleTheme$ = new ReplaySubject<boolean>(1);
    private readonly currentTheme$ = new ReplaySubject<ThemeType>(1);

    /** @ngInject */
    public constructor(private readonly currentUserService: CurrentUserService) {

    }

    public init() {
        this.currentUserService
            .current
            .map((c) => this.themeClass(c))
            .startWith("dark")
            .subscribe((theme) => this.currentTheme$.next(theme));

        this.currentUserService
            .current
            .map((c) => c.branding())
            .subscribe((branding) => document.body.classList.add(branding));
        this.currentTheme$
            .pairwise()
            .subscribe(([previous, next]) => {
                document.body.classList.remove(previous);
                document.body.classList.add(next);
            });
        this.toggleTheme$
            .withLatestFrom(this.currentUserService.current)
            .map(([_, user]) => user)
            .filter((user) => themingEnabled(user.branding()))
            .map((user) => this.themeClass(user))
            .map((theme) => this.switchTheme(theme))
            .subscribe((theme) => this.currentUserService.updatePreference("theme", theme));
    }

    private themeClass(user: CurrentUser): ThemeType {
        const preference = user.preferences.theme;
        if (preference != null) {
            return preference;
        } else {
            return defaultTheme(user.branding());
        }
    }

    private switchTheme(current: ThemeType): ThemeType {
        return (current === "light") ? "dark" : "light";
    }

    public toggleTheme() {
        this.toggleTheme$.next(true);
    }

    public get currentTheme(): Observable<ThemeType> {
        return this.currentTheme$;
    }
}
